// @flow
import React from 'react'
import styles from './styles.css'
import { fileSubtitle, isViewable } from 'lib/digital_file/viewer'
import type { DigitalFile } from 'lib/digital_file/model'

type Props = {
  legacy: Array<DigitalFile>,
  onView: (key: ?string, contentType: ?string, name: ?string) => mixed,
  onMove: (id: number) => mixed,
  onRename: (id: number) => mixed,
}

const LegacyRail = ({ legacy, onView, onMove, onRename }: Props) => {
  return (
    <aside className={styles.legacyRail}>
      <div className={styles.legacyRailTitle}>
        <span>Legacy queue</span>
        <span className={styles.legacyCount}>{legacy.length} left</span>
      </div>
      <div className={styles.legacyHint}>
        Use <strong>Move</strong> to place each item in a folder.
      </div>
      {legacy.map((file) => {
        const canRetrieve = Boolean(file.key)
        const canView = canRetrieve && isViewable(file)
        return (
          <div key={file.id} className={styles.queueItem}>
            <div className={styles.queueItemBody}>
              <div className={styles.queueName}>
                {file.name}
                <button
                  type="button"
                  title="Rename file"
                  className={styles.renameBtn}
                  onClick={() => onRename(file.id)}
                />
              </div>
              <div className={styles.queueMeta}>{fileSubtitle(file)}</div>
            </div>
            <div className={styles.queueItemActions}>
              {canView && (
                <button
                  type="button"
                  className={styles.queueBtn}
                  onClick={() => onView(file.key, file.content_type, file.name)}
                >
                  View
                </button>
              )}
              <button
                type="button"
                className={styles.queueBtnPrimary}
                onClick={() => onMove(file.id)}
              >
                Move
              </button>
            </div>
          </div>
        )
      })}
    </aside>
  )
}

export default LegacyRail
